import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignLeft } from '@fortawesome/free-solid-svg-icons';
import { Navbar, Button, NavbarToggler, Collapse, Nav, NavItem, NavLink,NavbarText } from 'reactstrap';
import LanguageSelector from "./LanguageSelector";


class NavBar2 extends React.Component {

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen  // navbar collapse
    });
  }



  render() {
    return (
      // <Navbar  style={ {background: "#aaa"} }  text="sfsdf" color="light" light className="navbar shadow-sm p-3 mb-5 bg-white rounded" expand="md">
      <Navbar  style={ {background: "#6d7fcc"} }  text="sfsdf" expand="md">
        <Button color="info" onClick={this.props.toggle}>
          <FontAwesomeIcon icon={faAlignLeft} />
        </Button>
        
        <LanguageSelector></LanguageSelector>


        <NavbarToggler onClick={this.toggle} />
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="ml-auto" navbar>
            <NavItem>
              <NavLink href="#"></NavLink>
            </NavItem>
            {/* <NavItem>
              <NavLink href="#">page</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="#">page</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="#">page</NavLink>
            </NavItem> */}
          </Nav>
          
        </Collapse>

        
      </Navbar>
    );
  }
}

export default NavBar2;
